<ng-container *ngIf="url !== '/login' && isLogin; else loginTemplate">
  <app-header [isLogin]="isLogin"></app-header>
</ng-container>

<ng-template #loginTemplate>
  <div>
    <router-outlet (activate)="componentAdded($event)"></router-outlet>
  </div>
</ng-template>